export const contentTableConfig = {
  title: '台账记录',
  propList: [
    {prop: 'customerName', label: '客户姓名', minWidth: '60'},
    {prop: 'customerNick', label: '客户昵称', minWidth: '60'},
    {prop: 'sexName', label: '性别', minWidth: '20'},
    {prop: 'developInfo', label: '开发信息', minWidth: '140'},
    {prop: 'customerInfo', label: '客户信息', minWidth: '140'},
    {label: '操作', minWidth: '80', slotName: 'handler'}
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
